import { render, staticRenderFns } from "./SubTransactionTypeTable.vue?vue&type=template&id=e5a4cd26&"
import script from "./SubTransactionTypeTable.vue?vue&type=script&lang=js&"
export * from "./SubTransactionTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports